export default __webpack_public_path__ + "static/media/C250253.8ab68df0.jpg";